import { useEffect, useState } from 'react';
import api from '../../utils/api';

export const AdBanner = ({ slot = "auto", format = "auto", className = "" }) => {
  const [showAd, setShowAd] = useState(false);
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    checkSubscriptionAndLoadAd();
  }, []);

  const checkSubscriptionAndLoadAd = async () => {
    try {
      const response = await api.get('/subscription/status');
      const { is_beta_tester, active_subscriptions } = response.data;
      
      // Don't show ads to premium users or beta testers
      const isPremium = active_subscriptions?.includes('premium') || 
                        active_subscriptions?.includes('profiles') ||
                        active_subscriptions?.includes('suggestions') ||
                        active_subscriptions?.includes('favorites');
      
      if (is_beta_tester || isPremium) {
        setShowAd(false);
        return;
      }

      // Show ads to free users
      setShowAd(true);
      
      // Load AdSense script if not already loaded
      if (!window.adsbygoogle && !document.querySelector('script[src*="adsbygoogle"]')) {
        const script = document.createElement('script');
        script.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4525161915809237';
        script.async = true;
        script.crossOrigin = 'anonymous';
        script.onload = () => setAdLoaded(true);
        document.head.appendChild(script);
      } else {
        setAdLoaded(true);
      }
    } catch (error) {
      console.error('Error checking subscription for ads:', error);
      // On error, show ads as fallback (assume free user)
      setShowAd(true);
    }
  };

  useEffect(() => {
    // Push ad when script is loaded and we should show ads
    if (showAd && adLoaded && window.adsbygoogle) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (e) {
        console.error('AdSense error:', e);
      }
    }
  }, [showAd, adLoaded]);

  // Don't render anything for premium/beta users
  if (!showAd) {
    return null;
  }

  return (
    <div className={`ad-container ${className}`} data-testid="ad-banner">
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4525161915809237"
        data-ad-slot="2972967716"
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      <p className="text-xs text-gray-400 text-center mt-1">Publicitat</p>
    </div>
  );
};

export default AdBanner;
